import { type ModalOpenResult, useModalStore } from '@tix/modal'

export function openDiscardWarningModal(onLeave: () => void, onStay: () => void): ModalOpenResult {
  // `onClose` runs for every close, including Leave. `onStay` can be triggered by: the user hitting "Continue", the "x",
  // or clicking outside the modal. Set `leaving` before close() on leave so `onStay` does
  // not run. If it did, the caller would treat the page as idle while we are still
  // clearing the cart and navigating away.
  let leaving = false
  return useModalStore().open({
    component: () => 'Any selections you’ve made will be discarded.',
    name: 'discard-warning',
    title: 'Are you sure you want to leave?',
    size: 'sm',
    closeable: true,
    dismissible: true,
    actions: [
      {
        hierarchy: 'primary',
        intent: 'cancel',
        label: 'Continue selection',
        onAction: (close) => close(),
      },
      {
        hierarchy: 'primary',
        intent: 'confirm',
        label: 'Leave',
        onAction: (close) => {
          leaving = true
          close()
          onLeave()
        },
      },
    ],
    onClose: () => {
      if (!leaving) onStay()
    },
  })
}
